import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useUser } from '../UserContext.js';
import { auth } from '../auth.js';
import { signOut } from "firebase/auth";

const Header = () => {
    const user = useUser();
    const [name, setName] = useState('');
    const [photo, setPhoto] = useState('');
    const [display, setDisplay] = useState('none');
    const [isSignedIn, setIsSignedIn] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setDisplay(location.state === '/home' ? 'inline' : 'none');
    }, [location]);

    useEffect(() => {
        if (user) {
            setName(user.displayName || '');
            setPhoto(user.photoURL || '');
            setIsSignedIn(true);
        } else {
            setName('');
            setPhoto('');
            setIsSignedIn(false);
        }
    }, [user]);

    function handleSignOut() {
        signOut(auth)
            .then(() => {
                navigate('/', { replace: true });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <div className="header">
            <div className="header-container">
                <Link to={'/'} state={'/home'}>
                    Unique
                    <span style={{ display }}>◂</span>
                </Link>
                {!isSignedIn && (
                    <div id="signin">
                        <Link to={`/signin`} className="navbar-link-title">
                            <i className="fa fa-sign-in" aria-hidden="true"></i>
                        </Link>
                    </div>
                )}
                {isSignedIn && (
                    <div id="signout">
                        {photo && <img src={photo} alt="" />}
                        <span>{name}</span>
                        <button onClick={handleSignOut}>
                            <i className="fa fa-sign-out" aria-hidden="true"></i>
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Header;
